import { TAKEOVER_COMPONENTS, TakeoverType } from './takeovers.constants';

interface WorkflowTakeoverProps {
  type: TakeoverType;
}

export const WorkflowTakeover = ({ type, ...props }: WorkflowTakeoverProps) => {
  const ModalComponent = TAKEOVER_COMPONENTS[type];

  return <ModalComponent {...props} />;
};
